<template>
  <v-dialog persistent width="1000" value="statusDialog">
    <v-card>
      <v-container>
        <v-alert v-if="detalle.error && detalle.error.length"
          color="error"
          icon="$error"
          title="Errores"
        >{{ detalle.error }}</v-alert>
        <v-btn icon text small @click="closeDialog(false)"
          ><v-icon>mdi-close</v-icon></v-btn
        >
        <v-divider />
        <h6 class="ml-1 font-weight-bold">Datos del Beneficiario</h6>
        <v-divider />
        <div>
          <v-row>
            <v-col cols="6">
              <v-row>
                <v-col cols="4">
                  <h6 class="font-weight-regular mt-1">Nombre Beneficiario:</h6>
                </v-col>
                <v-col cols="8">
                  <v-text-field  v-model="nombreBeneficiario" readonly filled dense />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row>
                <v-col cols="4">
                  <h6 class="font-weight-regular mt-1">Rut Beneficiario:</h6>
                </v-col>
                <v-col cols="8">
                  <v-text-field v-model="rutBeneficiario" readonly filled dense />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="mt-n8" cols="6">
              <v-row>
                <v-col cols="4">
                  <h6 class="font-weight-regular mt-1">Subdireccion:</h6>
                </v-col>
                <v-col cols="8">
                  <v-text-field v-model="detalle.subdireccion" readonly filled dense />
                </v-col>
              </v-row>
            </v-col>
            <v-col class="mt-n8" cols="6">
                <v-row>
                  <v-col cols="4">
                    <h6 class="font-weight-regular mt-1">Numero Cuenta Pago:</h6>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="detalle.numerocuentapago" readonly filled dense />
                  </v-col>
                </v-row>
              </v-col>
          </v-row>
          <v-if v-if="detalle.montos.moneda " >
            <row>
              <v-col>
                <v-divider />
                <h6 class="ml-1 font-weight-bold">Detalles Del Pago</h6>
                <v-divider />
              </v-col>
            </row>
            <v-row>
              <v-col class="mt-n6" cols="6">
                <v-row>
                  <v-col cols="4">
                    <h6 class="font-weight-regular mt-1">Monto Procesado:</h6>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="detalle.montos.montoProcesado" readonly filled dense />
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="mt-n6" cols="6">
                <v-row>
                  <v-col cols="4">
                    <h6 class="font-weight-regular mt-1">Monto Retencion:</h6>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="detalle.montos.montoRetencion" readonly filled dense />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-n8" cols="6">
                <v-row>
                  <v-col cols="4">
                    <h6 class="font-weight-regular mt-1">Medio de Pago:</h6>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="detalle.mediopago.nombreMedioPago" readonly filled dense />
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="mt-n8" cols="6">
                <v-row>
                  <v-col cols="4">
                    <h6 class="font-weight-regular mt-1">Monto Pago:</h6>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="detalle.montos.montoPagado" readonly filled dense />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-if>
          <v-if v-if="detalle.estado=='DEPOSITO_ENVIADO'" >
            <v-row>
              <v-col class="mt-n6" cols="6">
                <v-row>
                  <v-col cols="4">
                    <h6 class="font-weight-regular mt-1">Numero de Documento:</h6>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="detalle.mediopago.numeroDocumento" readonly filled dense />
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="mt-n6" cols="6">
                <v-row>
                  <v-col cols="4">
                    <h6 class="font-weight-regular mt-1">Fecha de Pago:</h6>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="detalle.mediopago.fechaPago" readonly filled dense />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-if>
          <v-if v-if="detalle.estado=='DOCUMENTO_ENVIADO'" >
            <v-row>
              <v-col class="mt-n6" cols="6">
                <v-row>
                  <v-col cols="4">
                    <h6 class="font-weight-regular mt-1">Numero de Documento:</h6>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="detalle.mediopago.numeroDocumento" readonly filled dense />
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="mt-n6" cols="6">
                <v-row>
                  <v-col cols="4">
                    <h6 class="font-weight-regular mt-1">Fecha de Pago:</h6>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="detalle.mediopago.fechaEmision" readonly filled dense />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-if>
        </div>
        <v-divider />
        <h6 class="ml-1 font-weight-bold">
          Datos de candidato o partido político
        </h6>
        <v-divider />
        <div class="mt-10">
          <v-row>
            <v-col class="mt-n8" cols="6">
              <v-row>
                <v-col cols="4">
                  <h6 class="font-weight-regular mt-1">
                    Nombre candidato o partido político:
                  </h6>
                </v-col>
                <v-col cols="8">
                  <v-text-field v-model="nombreCandidato" readonly filled dense />
                </v-col>
              </v-row>
            </v-col>
            <v-col class="mt-n8" cols="6">
              <v-row>
                <v-col cols="4">
                  <h6 class="font-weight-regular mt-1">Rut:</h6>
                </v-col>
                <v-col cols="8">
                  <v-text-field v-model="rutCandidato" readonly filled dense />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <v-divider />
        <h6 class="ml-1 font-weight-bold">Información de envío a TGR</h6>
        <v-divider />
        <div class="mt-10">
          <v-row>
            <v-col class="mt-n8" cols="6">
              <v-row>
                <v-col cols="4">
                  <h6 class="font-weight-regular mt-1">Transacción ID TGR:</h6>
                </v-col>
                <v-col cols="8">
                  <v-text-field v-model="detalle.id_transaccion" readonly filled dense />
                </v-col>
              </v-row>
            </v-col>
            <v-col class="mt-n8" cols="6">
              <v-row>
                <v-col cols="4">
                  <h6 class="font-weight-regular mt-1">Orden de pago:</h6>
                </v-col>
                <v-col cols="8">
                  <v-text-field v-model="detalle.numeroordenpago" readonly filled dense />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <div class="mt-5 d-flex justify-end">
          <v-btn @click="closeDialog(false)" color="primary">Cerrar</v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "ModalEstadoEgresoComponents",
  data() {
    return {

    };
  },
  mounted () {
    // if(this.detalle !== {}){
         console.log("detalle",this.detalle);
    // }
  },
  computed: {
    ...mapGetters("estadoEgreso", ["detalle"]),

    nombreBeneficiario(){ return `${this.detalle.nombrebeneficiario? this.detalle.nombrebeneficiario : '' } ${this.detalle.apellidopaternobeneficiario} ${this.detalle.apellidomaternobeneficiario ? this.detalle.apellidomaternobeneficiario : ''}`},
    rutBeneficiario(){ return `${this.detalle.rutbeneficiario}-${this.detalle.dvbeneficiario}`},
    nombreCandidato(){ return `${this.detalle.nombre ? this.detalle.nombre: ''} ${this.detalle.apellidopaterno ? this.detalle.nomapellidopaternobre: ''} ${this.detalle.apellidomaterno ? this.detalle.apellidomaterno: ''}`},
    rutCandidato(){return `${this.detalle.rut}-${this.detalle.dv}`},
  },
  methods: {
    ...mapMutations("estadoEgreso", ["setDetalle"]),
    closeDialog(status) {
      this.setDetalle({});
      this.$emit("closeDialog", status);
    },
  },
};
</script>

<style lang="scss" scoped></style>
